import bnc           from 'bnc';

export const block = new bnc('b-hint');
